import { Component, OnInit, Inject, OnDestroy, ViewChild } from "@angular/core";
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import * as _ from 'lodash';

import { Router, ActivatedRoute } from "@angular/router";
import { HttpResponse } from '@angular/common/http';

import { ServiceService } from "./../../../../../services/service.service";

import { timer, Observable, Subject ,of, Subscription} from 'rxjs';
import { switchMap, takeUntil, catchError } from 'rxjs/operators';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { SortingModel } from '../dashboard-mngnt/sortingModel';

@Component({
  selector: 'app-dynamic-chart',
  templateUrl: './dynamic-chart.component.html',
  styleUrls: ['./dynamic-chart.component.sass']
})
export class DynamicChartComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  cnt: number = 0;

  isUserExist: boolean = false;
  errorResMessage: string = '';

  error: boolean = false;
  errMessage: string = "";
  validation: boolean = false;
  formSubmission: boolean = false;
  formData = new FormData();
  status: string = "";
  id: string = "";
  apiResponse: boolean = false;

  response: any = {
    heapSize: [],
    heapMaxSize: [],
    heapFreeSize: [],
    tStamp: []
  };

  hoveredDate: NgbDate;

  fromDate: NgbDate;
  toDate: NgbDate;
  from_date: string;
  to_date: string;

  private loggedIn: boolean;

  // @ViewChild("form") form: any;
  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService,
  ) {
    if(!localStorage.getItem("access_token") || localStorage.getItem("access_token") === '') {
      this.router.navigate(["/"]);
    }

    this.fromDate = calendar.getNext(calendar.getToday(), 'd', 0);

    this.toDate = calendar.getNext(calendar.getToday(), 'd', 1);

    const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
    this.from_date = this.datePipe.transform(fromDate, 'yyyy-MM-dd');
    this.to_date = this.datePipe.transform(toDate, 'yyyy-MM-dd');
  }
  
  


  

  ngOnInit() {
    this.getHeapStatus();
    this.subscription = timer(0, 50000).pipe(
      switchMap(() => this.getHeapStatus())
    ).subscribe(result => {});

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public lineChartData: any[] = [
    { data: this.response.heapSize, label: 'Heap Size',  pointRadius: 5, pointBorderColor: "black", pointBorderWidth: 2, 
    pointBackgroundColor:"yellow",},
    { data: this.response.heapMaxSize, label: 'Heap Max Size',  pointRadius: 5, pointBorderColor: "red", pointBorderWidth: 2, 
    pointBackgroundColor:"yellow"},
    { data: this.response.heapFreeSize, label: 'Heap Free Size',  pointRadius: 5, pointBorderColor: "blue", pointBorderWidth: 2, 
    pointBackgroundColor:"yellow"}
  ];
  public lineChartLabels: Label[] = this.response.tStamp;
  // public lineChartOptions: (ChartOptions & { annotation: any }) = {
  //   responsive: true,
  // };
  public lineChartOptions: any = {};
  public lineChartColors: Color[] = [
    {
      borderColor: 'black',
      backgroundColor: '#627d9433',
    },
    {
      borderColor: 'red',
      backgroundColor: '#c353671c',
    },
    {
      borderColor: 'blue',
      backgroundColor: '#24ca851c',
    },
    {
      borderColor: 'yellow',
      backgroundColor: '#6165639e',
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];

  public getHeapStatus(): Observable<string> {
    $(".overlay-loading").show();
    this.service.getHeapStatus(this.from_date, this.to_date).subscribe((res) => {
      this.apiResponse = true;
      this.response = res;

      this.lineChartData[0].data = this.response.heapSize;
      this.lineChartData[1].data = this.response.heapMaxSize;
      this.lineChartData[2].data = this.response.heapFreeSize;

      this.lineChartLabels = this.response.tStamp;

      $(".overlay-loading").hide();
    }, error=> {

    });

    return of("Last information10");
  }
    



  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate, input: string): NgbDate {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

}
